module.exports = __webpack_public_path__ + "media/video.37bba007.mp4";